import { apiGet, apiPost } from '@/lib/api-client';

import { LoginResponse, User } from './schemas';

export async function fetchCurrentUser(): Promise<User> {
  const raw = await apiGet<unknown>('/auth/me');
  return User.parse(raw);
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  const raw = await apiPost<unknown>('/auth/login', { email, password }, { skipAuth: true });
  return LoginResponse.parse(raw);
}
